import { render } from "./HeroListShowDetailInfoBase.vue?vue&type=template&id=19532950&scoped=true"
import script from "./HeroListShowDetailInfoBase.vue?vue&type=script&lang=js"
export * from "./HeroListShowDetailInfoBase.vue?vue&type=script&lang=js"

import "./HeroListShowDetailInfoBase.vue?vue&type=style&index=0&id=19532950&scoped=true&lang=css"

import exportComponent from "/Users/gaomingliang/github/vue3_wzheros/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19532950"]])

export default __exports__